/**
 * Formats the given duration to mm:ss
 * @param durationSeconds Duration in seconds
 * @returns Formatted string mm:ss
 */
export default function timeFormat (durationSeconds: number): string {
  const seconds = Math.floor(durationSeconds % 60)
  const secondsString = seconds < 10 ? `0${seconds}` : `${seconds}`
  const minutes = Math.floor(durationSeconds / 60)
  return `${minutes}:${secondsString}`
}